import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'

Vue.use(Router)

const routes = [
  //首页
  {
  path: '/',
  component: Layout,
  children: [{
    path: '',
    component: () => import('@/views/Index')
  }]
  },
  // 文献列表页
  {
    path: '/',
    component: Layout,
    children: [{
      path: 'book-list',
      component: () => import('@/views/BookList')
    }]
  },
  //图片资源列表页
  {
    path: '/',
    component: Layout,
    children: [{
      path: 'image-list',
      component: () => import('@/views/ImageList')
    }]
  },
  // 详情页
  {
    path: '/',
    component: Layout,
    children: [{
      path: 'detail/:resourceId/type/:type',
      name: 'Detail',
      component: () => import ('@/views/Detail/index')
    }]
  },
  // 搜索列表页
  {
    path: '/',
    component: Layout,
    children: [{
      path: 'search/scope/:scope/keyword/:keyword',
      name: 'Search',
      component: () => import ('@/views/SearchList')
    }]
  },
  // 阅读页
  {
    path: '/reader/:resourceId/type/:type',
    name:'Reader',
    component: () => import ('@/views/Reader/index')
  }
]

const router = new Router(({
  mode: 'history',
  routes: routes,
  scrollBehavior(){
    return {x : 0, y: 0}
  }
}))

export default router